/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@emotion/core';
const containerCss = css({
    display: 'inline-table',
    textDecoration: 'underline',
});
const previewCss = css({
    display: 'table-caption',
    captionSide: 'bottom',
    position: 'relative',
    userSelect: 'none',
});
const InlinePreview = React.forwardRef((props, ref) => {
    const { children, preview, ...spanProps } = props;
    return (jsx("span", Object.assign({ ref: ref }, spanProps, { css: containerCss }),
        children,
        jsx("span", { contentEditable: false, css: previewCss }, preview)));
});
export default React.memo(InlinePreview);
//# sourceMappingURL=InlinePreview.js.map